import type { ReactNode } from 'react';
import { cn } from '@/lib/infra/utils';

/** The actionable state stays visible. Reference detail opens deliberately,
 * with a keyboard/touch control rather than an automatic hover over the order. */
export function UsTicketNotice({ summary, children, testId, warning = true, className, title }: {
  summary: string; children: ReactNode; testId?: string; warning?: boolean; className?: string; title?: string;
}) {
  return <details data-testid={testId} title={title} role={warning ? 'alert' : 'status'} className={cn('min-w-0 text-[11px] leading-4',
    warning ? 'text-amber-500 light:text-amber-700' : 'text-muted-foreground', className)}>
    <summary className="flex cursor-pointer list-none items-baseline gap-2 [&::-webkit-details-marker]:hidden">
      <span className="min-w-0 flex-1 break-words">{summary}</span>
      <span className="shrink-0 underline underline-offset-2">Details</span>
    </summary>
    <div className="mt-1 space-y-1 break-words text-muted-foreground [overflow-wrap:anywhere]">{children}</div>
  </details>;
}
